{
  "completed": "مكتمل: ",
  "current": "الحالي: ",
  "notCompleted": "غير مكتمل: ",
  "steplist": "قائمة الخطوات"
}
